// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"hZ-z","sponsoredTooltipWrapper":"iZ-z","sponsoredTooltip":"jZ-z","newCard":"kZ-z"};